export const SEARCHTYPE = ['Username', 'Company', 'Role', 'Business Entity'];

/* eslint-disable flowtype/no-types-missing-file-annotation */
export const INPUT_TEXT_CHANGE = 'INPUT_SEARCH_USER_TEXT_CHANGE';
export const SELECT_TYPE_CHANGE = 'SELECT_USER_SEARCH_TYPE_CHANGE';
export const SELECT_ACTIONTYPE_CHANGE = 'SELECT_USER_ACTION_TYPE_CHANGE';
export const GET_USER = 'GET_USER';
export const GET_USERS = 'GET_USERS';
export const GET_ROLES = 'GET_ROLES';
export const GET_TIMEZONES = 'GET_TIMEZONES';
export const GET_ENTITIES = 'GET_ENTITIES';
export const GET_USER_RESTRICTIONS = 'GET_USER_RESTRICTIONS';
export const UPDATE_USER_FIELD = 'UPDATE_USER_FIELD';
export const SET_PASSWORD = 'SET_PASSWORD';

export const ROLES = [
  'Product Manager',
  'Driver',
  'Fleet Manager',
  'HR Manager',
  'People Manager',
  'Company Admin'
];



// WEBPACK FOOTER //
// ./src/features/userManagement/store/TYPES.js